import { BasePlugin } from '../../core/base-plugin';
import { ErrorData } from './types';

export class ErrorPlugin extends BasePlugin {
  public name = 'error';
  private errorHandler: (event: ErrorEvent) => void;
  private rejectionHandler: (event: PromiseRejectionEvent) => void;

  constructor() {
    super();
    this.errorHandler = this.handleError.bind(this);
    this.rejectionHandler = this.handleRejection.bind(this);
  }

  public init(): void {
    window.addEventListener('error', this.errorHandler, true);
    window.addEventListener('unhandledrejection', this.rejectionHandler);
  }

  public destroy(): void {
    if (this.errorHandler) {
      window.removeEventListener('error', this.errorHandler, true);
    }
    if (this.rejectionHandler) {
      window.removeEventListener('unhandledrejection', this.rejectionHandler);
    }
  }

  private shouldIgnoreError(error: Error | string): boolean {
    const ignoreErrors = (this.config.ignoreErrors || []) as RegExp[];
    const errorMessage = error instanceof Error ? error.message : error;
    return ignoreErrors.some(pattern => pattern.test(errorMessage));
  }

  private handleError(event: ErrorEvent): void {
    if (this.shouldIgnoreError(event.error || event.message)) return;

    const data: ErrorData = {
      type: 'error',
      subType: 'javascript',
      message: event.message,
      filename: event.filename,
      position: `${event.lineno}:${event.colno}`,
      stack: event.error?.stack,
    };
    this.report?.(data);
  }

  private handleRejection(event: PromiseRejectionEvent): void {
    const error = event.reason;
    if (this.shouldIgnoreError(error)) return;

    const data: ErrorData = {
      type: 'error',
      subType: 'promise',
      message: error?.message || error,
      stack: error?.stack,
    };
    this.report?.(data);
  }
} 